export default "__VITE_ASSET__DPePpCDV__"